import store from "@/state/store";

export default [
    {
        path: "/",
        name: "dashboard",
        meta: {
            authRequired: true,
        },
        component: () => import("./views/dashboard")
    },
    {
        path: "/stagiaire",
        name: "student",
        meta: {
            authRequired: true
        },
        component: () => import("./views/student")
    },
    {
        path: "/enquetes",
        name: "surveys",
        meta: {
            authRequired: true
        },
        component: () => import("./views/surveys")
    },
    {
        path: "/questions",
        name: "questions",
        meta: {
            authRequired: true
        },
        component: () => import("./views/questions")
    },
    {
        path: "/stagiaires",
        name: "students",
        meta: {
            authRequired: true
        },
        component: () => import("./views/students")
    },
    {
        path: "/efp",
        name: "efp",
        meta: {
            authRequired: true
        },
        component: () => import("./views/efp")
    },
    {
        path: "/filieres",
        name: "branchs",
        meta: {
            authRequired: true
        },
        component: () => import("./views/branchs")
    },
    {
        path: "/utilisateurs",
        name: "users",
        meta: {
            authRequired: true
        },
        component: () => import("./views/users")
    },
    {
        path: "/importer",
        name: "import",
        meta: {
            authRequired: true
        },
        component: () => import("./views/import")
    },
    {
        path: "/login",
        name: "login",
        component: () => import("./views/account/login"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "default" });
                } else {
                    // Continue to the login page
                    next();
                }
            }
        }
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("./views/account/register"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "default" });
                } else {
                    // Continue to the login page
                    next();
                }
            }
        }
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("./views/account/forgot-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "default" });
                } else {
                    // Continue to the login page
                    next();
                }
            }
        }
    },
    {
        path: "/logout",
        name: "logout",
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch("auth/logOut");
                } else {
                    store.dispatch("authfack/logout");
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(route => route.push("/login"));
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom });
            }
        }
    },
    {
        path: "/profile",
        name: "profile",
        meta: {
            authRequired: true
        },
        component: () => import("./views/profile")
    },
    {
        path: "/404",
        name: "404",
        component: require("./views/utility/404").default
    },
    {
        path: "/403",
        name: "403",
        component: require("./views/utility/403").default
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
        path: "*",
        redirect: "404"
    }
];
